module.exports = {"audiences":["allMembers"],"experimentVersion":"v1","experimentAllocation":0.2,"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/superHomeTeamBoards.json
// module id = +0Jd
// module chunks = 1